import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { srConfig } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';

const StyledAboutSection = styled.section`
  max-width: 900px;

  .inner {
    // display: grid;
    // grid-template-columns: 3fr 2fr;
    // grid-gap: 50px;

    @media (max-width: 768px) {
      display: block;
    }
  }
`;
const StyledText = styled.div`
  ul.skills-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(140px, 200px));
    grid-gap: 0 10px;
    padding: 0;
    margin: 20px 0 0 0;
    overflow: hidden;
    list-style: none;

    li {
      position: relative;
      margin-bottom: 10px;
      padding-left: 20px;
      font-family: var(--font-mono);
      font-size: var(--fz-xs);

      &:before {
        content: '▹';
        position: absolute;
        left: 0;
        color: var(--green);
        font-size: var(--fz-sm);
        line-height: 12px;
      }
    }
  }
`;
const About = () => {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, []);

  const skills = [
    'JavaScript (ES6+)',
    'TypeScript',
    'React.js',
    'React Native',
    'Electron.js',
    'Node.js',
    'Express.js',
    'MongoDB',
    'MySQL',
    'SQLite',
    'Python',
    'PHP',
    'SuiteCRM',
    'SugarCRM',
    'Socket.io',
  ];

  return (
    <StyledAboutSection id="about" ref={revealContainer}>
      <h2 className="numbered-heading">About Me</h2>

      <div className="inner">
        <StyledText>
          <div>
            <p>
              Hello! I'm Umair Younas, a Full-Stack Software Engineer with 3+ years of experience
              building scalable web, desktop, and mobile applications that drive real business
              efficiency.
            </p>
            <p>
              I specialize in MERN stack development (MongoDB, Express.js, React, Node.js) for
              scalable web applications, React Native for cross-platform mobile development, and
              Electron.js for offline-first desktop systems. I also build Python-based workflow
              automation engines and implement enterprise CRM solutions using SuiteCRM and SugarCRM.
            </p>
            <p>
              I thrive on complex integration challenges — whether it's architecting offline-first
              systems with bidirectional cloud sync, integrating payment gateways like Stripe,
              connecting ERP platforms like SAP and ERPNext, implementing real-time features with
              Socket.io, or replacing legacy workflows with scalable automation pipelines.
            </p>

            <p>Here are a few technologies I’ve been working with recently:</p>
          </div>

          <ul className="skills-list">
            {skills && skills.map((skill, i) => <li key={i}>{skill}</li>)}
          </ul>
        </StyledText>

        {/* <StyledPic>
          <div className="wrapper">
            <StaticImage
              className="img"
              src="../../images/me.jpg"
              width={500}
              quality={95}
              formats={['AUTO', 'WEBP', 'AVIF']}
              alt="Headshot"
            />
          </div>
        </StyledPic> */}
      </div>
    </StyledAboutSection>
  );
};

export default About;
